import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import Icon from 'components/icon/icon'

import { saveUser } from 'state/actions'
import { doClickEventListeners } from 'utils'

class ModalAnnouncement extends Component {
    // I know, this is really confusing, but this is only for "What's New With Hassl?" announcements.
    // Regular announcements are in modal-feedback.
    
    dismiss = _ => {
        let userData = {
            ...this.props.userData,
            last_seen_announcement_id: this.props.data.id
        }

        this.props.saveUser(userData)

        this.props.closeCallback()
    }

	handleClick = e => {
		if(!this.ref.contains(e.target)){
			this.dismiss()
        }
	}
 
	UNSAFE_componentWillMount(){
        doClickEventListeners(this.handleClick)
	}

	componentWillUnmount(){
		doClickEventListeners(this.handleClick, true)
	}

	render() {
        if(!this.props.data){
            return null 
        }

		return(
			<div ref={e => this.ref = e}>
                <div className="announcement">
                    <div className="copy-container" dangerouslySetInnerHTML={{ __html: this.props.data.copy }} />
                    <Button size={'big'} level={'high'} callback={_ => {this.dismiss()}} label={'Okey doke'} icon={'check'} />
                </div>
			</div>
		);
	}
}

export default connect(null, {saveUser})(ModalAnnouncement);
